import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { strictMode } from './consistents';
import { setupSentry } from './sentry';

async function enableMocking() {
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_MSW === 'true'
  ) {
    const { setupWorker } = await import('msw/browser');
    const { handlers } = await import('./mocks/handlers');

    const worker = setupWorker(...handlers);

    return worker.start();
  }
}

enableMocking().then(() => {
  setupSentry();

  const root = createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    strictMode ? (
      <StrictMode>
        <App />
      </StrictMode>
    ) : (
      <App />
    )
  );
});
